/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const pwaLinks = [
  { rel: "manifest", href: "/manifest.webmanifest" },
  { rel: "icon", href: "/icons/icon-192.png", sizes: "192x192", type: "image/png" },
  { rel: "apple-touch-icon", href: "/icons/apple-touch-icon.png", sizes: "180x180" },
];

for (const attributes of pwaLinks) {
  const link = document.createElement("link");
  for (const [name, value] of Object.entries(attributes)) link.setAttribute(name, value);
  document.head.append(link);
}

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);

if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js");
  });
}
